import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { Nav } from "react-bootstrap";
import { Navbar } from "react-bootstrap";
import logo from '../Assets/img/logo.png';
import Connect from './Connect';
import { getWeb3 } from '../helper/connectors';
import bscstakeAbi from '../json/bscstake.json';
import { DEFAULT_CHAIN, contract } from '../helper/constant';
import { Link } from 'react-router-dom';
import { useAccount } from 'wagmi';



const Header = () => {
    const [sticky, setSticky] = useState("");
    const [owner, setOwner] = useState("")
    const {address , isConnected} = useAccount()
  

    useEffect(() => {
        window.addEventListener("scroll", isSticky);
        return () => {
            window.removeEventListener("scroll", isSticky);
        };
    }, []);

    const isSticky = () => {
        const scrollTop = window.scrollY;
        const stickyClass = scrollTop >= 150 ? "is-sticky" : "";
        setSticky(stickyClass);
    }
    const classes = `header-section ${sticky}`;

    useEffect(() => {
        async function fetch() {
            let web3 = getWeb3();
            let stakeContract = new web3.eth.Contract(bscstakeAbi, contract[DEFAULT_CHAIN].STAKE_ADDRESS);
            let owner = await stakeContract.methods.owner().call();
            setOwner(owner);
        }
        if (address) {
            fetch();
        }
        else {
            setOwner('')
        }
    }, [address])

    return (
        <>
            <Navbar className={`${classes} main-header navbar-dark`} expand="lg">
                <Container>
                    <a target="_blank"  rel="noreferrer" href="https://www.ricesnetwork.com/">
                        <Navbar.Brand>
                            <img src={logo}  className='logo-img' alt="BKR Logo" />
                        </Navbar.Brand>
                    </a>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="align-items-lg-center ms-auto">
                            <Nav.Link className="text-white" href="https://www.ricesnetwork.com" target="_blank">Website</Nav.Link>
                            <Nav.Link className="text-white" href="https://opensea.io/collection/the-eggsmoon-card" target="_blank">NFT</Nav.Link>
                            <Nav.Link className="text-white" href="https://www.ricesnetwork.com/seed-paper/" target="_blank">Seedpaper</Nav.Link>
                            {address && isConnected && address.toLowerCase() === owner.toLowerCase() &&
                                <Nav.Link className='text-white'><Link to="/admin">Admin</Link></Nav.Link>
                            }
                            <Connect />
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    )
}

export default Header